<template>
  <div class="bg-white pt-3 border rounded shadow-sm">
    <div class="font-semibold mx-2 text-gray-600">Repeat Visitors</div>
    <div class="flex justify-between pt-2 px-3">
      <div>
        <label class="block tracking-wide text-gray-700">Records</label>
        <select v-model="recordsPerPage"
                class="block appearance-none w-full bg-white border border-gray-300  px-4 py-2  rounded leading-tight focus:outline-none focus:border-gray-500">
          <option>5</option>
          <option>10</option>
          <option>25</option>
          <option>50</option>
          <option>100</option>
          <option>250</option>
        </select>
      </div>
      <div>
        <label class="block tracking-wide text-gray-700">Search</label>
        <input v-model="searchString" @change="loadStats(currentPage)"
               class="appearance-none block w-full text-gray-700 border border-gray-300 rounded py-2 px-4 leading-tight focus:outline-none focus:border-gray-500"
               type="text" placeholder="Search">
      </div>
    </div>
    <div class=" overflow-auto ">
      <table v-if="!loading" class="table-auto w-full mb-3 ">
        <thead>
        <tr class="border-b font-bold">
          <td class="px-3 py-2"></td>
          <td class="px-3 py-2">Name</td>
          <td class="px-3 py-2">Phone Number</td>
          <td class="px-3 py-2">Email Address</td>
          <td class="px-3 py-2">Facebook</td>
          <td class="px-3 py-2">Twitter</td>
          <td class="px-3 py-2">More info</td>
          <td class="px-3 py-2">Devices</td>
          <td class="px-3 py-2">Connections</td>
        </tr>
        </thead>
        <tbody>
        <tr class="border-t hover:bg-gray-200" v-for="(customer,index) in records" :key="customer.id">
          <td class="px-3 py-2 font-bold">
            {{ offset + index + 1 }}
          </td>
          <td class="px-3 py-2">
            <router-link :to="{name:'customer_profile', params:{customerId: customer.id}}">
              {{ customer.identity }}
            </router-link>
          </td>
          <td class="px-3 py-2">{{ customer.phone_number }}</td>
          <td class="px-3 py-2">{{ customer.email_address }}</td>
          <td class="px-3 py-2">{{ customer.facebook }}</td>
          <td class="px-3 py-2">{{ customer.twitter }}</td>
          <td class="px-3 py-2">{{ customer.more_info }}</td>
          <td class="px-3 py-2">{{ customer.devicesCount }}</td>
          <td class="px-3 py-2">{{ customer.connectionsCount }}</td>
        </tr>
        </tbody>
      </table>
      <div v-else class="py-6 text-center w-full">
        <feather animation="spin" type="loader" size="32" class="mr-4"></feather>
        <p>Loading...</p>
      </div>
    </div>
    <Pagination class="py-2 px-3" :total-count="recordsCount" :current-page="currentPage"
                :tag="'users'"
                :offset="offset"
                :records-count="records != null ? records.length || 0 : 0"
                :click-handler="loadStats" :records-per-page="parseInt(recordsPerPage)"/>
  </div>
</template>

<script>
import moment from "moment";
import GraphQl from "../../services/graphql.service";
import Pagination from "@/components/Pagination";

export default {
  name: "RepeatVisitorsReport",
  components: {Pagination},
  data() {
    return {
      searchString: '',
      recordsPerPage: 10,
      records: [],
      recordsCount: 0,
      orgId: this.$store.getters.orgId,
      currentPage: 1,
      loading: true
    }
  },
  props: {
    configs: Object
  },
  mounted() {
    this.loadStats();
  },
  watch: {
    recordsPerPage: function () {
      this.loadStats(this.currentPage)
    },
    searchString: function () {
      this.currentPage = 1;
    },

    configs: {
      handler: function () {
        this.loadStats();
      },
      deep: true
    }
  },

  computed: {
    offset: function () {
      return (this.currentPage - 1) * this.recordsPerPage;
    }
  },
  methods: {
    formatDate(timestamp, format) {
      return moment(timestamp).format(format);
    },
    loadStats(newPage) {
      this.currentPage = newPage || 1;
      this.loading = true
      let params = (this.configs.venues.length > 0 ? 'venues:["' + this.configs.venues.join('","') + '"],' : '') +
          'endDate: "' + this.configs.startDate + '", ' +
          'startDate: "' + this.configs.endDate + '", ' +
          'limit: ' + this.recordsPerPage + ', ' +
          'offset: ' + this.offset + ', ' +
          'order: "created_at desc", ' +
          'search: "' + this.searchString + '"';

      let query = 'repeatVisitorsCount(' + params + ')  uniqueVisitors(' + params + '){id name phone_number email_address twitter facebook identity more_info connectionsCount devicesCount}'
      GraphQl.sendRequest('{' + query + '}')
          .then(response => {
            this.records = response.uniqueVisitors;
            this.uniqueVisitorsCount = response.uniqueVisitorsCount;
          })
          .finally(() => {
            this.loading = false;
          })
    }
  }
}
</script>

<style scoped>
</style>